// [Style] - Constants used throughout the site to enforce consistency
export const colors = {
  white: '#FFFFFF',
  whiteHover: '#CBF5FE',
  graphite: '#1C2F42',
  lightGrey: '#F3F3F3',
  cyan: '#06C2FC',
  cyanHover: '#0097FF',
  magenta: '#FB16BB',
  orange: '#FFA000',
  blue: '#0054A4',
  blueHover: '#00407E',
  cowayBlue: '#00CBF9',
  fanduelRed: '#C61B3D',
  fanduelBlue: '#006CD3',
  disneyRed: '#EC4621',
  disneyViolet: '#69219D'
};

export const rgbColors = {
  white: 'rgba(255, 255, 255, 1)',
  whiteHover: 'rgba(203, 245, 254, 0.9)',
  graphite: 'rgba(28, 47, 66, 1)',
  lightGrey: 'rgba(243, 243, 243, 0.9)',
  cyan: 'rgba(6, 194, 252, 1)',
  cyanHover: 'rgba(0, 151, 255, 0.9)',
  magenta: 'rgba(251, 22, 187, 1)',
  orange: 'rgba(255, 160, 0, 1)',
  blue: 'rgba(0, 84, 164, 1)',
  blueHover: 'rgba(0, 64, 126, 0.9)'
};

export const circleColorMap = [
  'rgba(6,194,252, 0.9)', // cyan
  'rgba(255, 160, 0, 0.9)', // orange
  'rgba(255, 74, 212, 0.9)', // magenta
  'rgba(0, 84, 164, 0.9)' // blue
];

export const mediaValues = {
  smallPhone: 320,
  phone: 360,
  workdetail1stBreakpoint: 430,
  workdetail2ndBreakpoint: 640,
  tabletPortrait: 768,
  tabletLandscape: 1024,
  desktop: 1280,
  bigDesktop: 1800
};

export const media = {
  smallPhone: `${mediaValues.smallPhone}px`,
  phone: `${mediaValues.phone}px`,
  workdetail1stBreakpoint: `${mediaValues.workdetail1stBreakpoint}px`,
  workdetail2ndBreakpoint: `${mediaValues.workdetail2ndBreakpoint}px`,
  tabletPortrait: `${mediaValues.tabletPortrait}px`,
  tabletLandscape: `${mediaValues.tabletLandscape}px`,
  desktop: `${mediaValues.desktop}px`,
  bigDesktop: `${mediaValues.bigDesktop}px`
};

export const throttlePeriod = 300;

export const animation = {
  animationDuration: 300,
  homeCircle: 1400,
  footerCircle: 800,
  introCircle: 1500,
  shortAnimationDuration: 200,
  navColorDuration: 150,
  delayOffset: 100,
  delayNav: 500,
  transitionName: 'animate',
  transitionTimingFn: 'ease-out',
  firstSectionOffset: 200 /*header bubble moves out*/,
  lastSectionOffset: '10%' /*footer bubble moved in*/
};
